// extracted by mini-css-extract-plugin
export var animationContainer = "_i2-0";
export var footer = "_i2-1";
export var gray = "_i2-2";
export var lineItem = "_i2-3";
export var lineItemImage = "_i2-4";
export var lineItemInfo = "_i2-5";
export var lineItemText = "_i2-6";
export var lineItems = "_i2-7";
export var modalContent = "_i2-8";
export var options = "_i2-9";
export var orderName = "_i2-a";
export var refundAmount = "_i2-b";